<template>
	<v-navigation-drawer v-model="drawerExtended" :mini-variant="miniVariant" v-bind="$attrs">
		<v-list dark nav dense class="navigationList">
			<template v-for="(item, index) of allowedNavItems">
				<v-list-group v-if="item.sub" :group="item.path" :key="item.name" class="my-1 listGroup">
					<template v-slot:activator>
						<l-tooltip right nudge-right="10" :disabled="!miniVariant">
							<template v-slot:activator="{ on, attrs }">
								<v-list-item-icon v-on="on" v-bind="attrs" class="mr-3 mt-2 ml-2">
									<!-- uncomment next element if you prefer colored sub-menu root element -->
									<!-- <v-icon :class="{ activeGolden: item.active && mini }">{{ item.icon }}</v-icon> -->
									<!-- comment next element if you prefer colored sub-menu root element -->
									<v-icon>{{ item.icon }}</v-icon>
								</v-list-item-icon>
							</template>
							<span>{{ globalTranslate(item.name) }}</span>
						</l-tooltip>
						<v-list-item-content>
							<v-list-item-title>{{ globalTranslate(item.name) }}</v-list-item-title>
						</v-list-item-content>
					</template>
					<!-- uncomment next element if you prefer v-divider below sub-menu root element -->
					<v-divider :key="'divider' + index" v-if="item.active && mini" class="customGoldDivider dottedBorder" />

					<v-list-item
						v-for="(subItem, subIndex) of item.sub"
						:key="subIndex + subItem.name"
						:to="subItem.path"
						class="ml-4"
					>
						<l-tooltip right nudge-right="10" :disabled="!miniVariant">
							<template v-slot:activator="{ on, attrs }">
								<v-list-item-icon v-on="on" v-bind="attrs" class="mr-1 mt-2">
									<v-icon small>{{ subItem.icon }}</v-icon>
								</v-list-item-icon>
							</template>
							<span>{{ globalTranslate(subItem.name) }}</span>
						</l-tooltip>
						<v-list-item-title>{{ globalTranslate(subItem.name) }}</v-list-item-title>
					</v-list-item>
				</v-list-group>

				<v-list-item v-else :key="item.name" :to="item.path" class="my-1">
					<l-tooltip right nudge-right="10" :disabled="!miniVariant">
						<template v-slot:activator="{ on, attrs }">
							<v-list-item-icon v-on="on" v-bind="attrs" class="mr-3 mt-2 ml-2">
								<v-icon>{{ item.icon }}</v-icon>
							</v-list-item-icon>
						</template>
						<span>{{ globalTranslate(item.name) }}</span>
					</l-tooltip>
					<v-list-item-title>{{ globalTranslate(item.name) }}</v-list-item-title>
				</v-list-item>

				<v-divider :key="index" v-if="index + 1 < navItems.length" class="customGoldDivider" />
			</template>
		</v-list>
		<template v-slot:append v-if="!miniVariant">
			<div class="d-flex justify-space-around">
				<span class="caption white--text">CMTool - Copyright &copy; Apluris e.U.</span>
			</div>
		</template>
	</v-navigation-drawer>
</template>

<script>
import { mapState } from 'pinia';
import { useAuthStore } from '@/plugins/auth/store';
import LTooltip from '@/components/base/LTooltip.vue';

export default {
	name: 'LNavigation',
	components: { LTooltip },
	props: {
		value: Boolean,
		navItems: Array,
		miniVariant: {
			type: Boolean,
			required: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		drawerExtended: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
		...mapState(useAuthStore, { currentUser: 'login' }),
		allowedNavItems() {
			return this.filterBasedOnRoles({ user: this.currentUser, navItems: JSON.parse(JSON.stringify(this.navItems)) });
		},
	},
	methods: {
		filterBasedOnRoles({ user, navItems }) {
			const out = [];
			for (const navItem of navItems) {
				const allowedRoles = this.$_.get(navItem, 'meta.roles');
				let allowed = false;
				if (!allowedRoles) {
					allowed = true;
				} else {
					const matchingRoles = this.$_.intersection(allowedRoles, user.effectiveFrontendRoles);
					if (matchingRoles.length) allowed = true;
				}

				if (allowed) {
					if (navItem.sub) navItem.sub = this.filterBasedOnRoles({ user, navItems: navItem.sub });
					if (!navItem.sub || navItem.sub.length) out.push(navItem);
				}
			}
			return out;
		},
		globalTranslate(value) {
			return this.$i18n.tc('$global.routes.' + value, 2);
		},
	},
};
</script>

<style scoped lang="scss">
.customGoldDivider {
	border-color: var(--v-golden-base) !important;
}
.dottedBorder {
	border-style: dashed !important;
}
.activeGolden {
	color: var(--v-golden-base) !important;
}
</style>
